import { css } from '@emotion/react';
import { MUI_PRIMARY_MAIN } from '../../themes/tokens';
import styled from '@emotion/styled';
import { Box, Container, CircularProgress } from '@mui/material';
import { Typography } from '@mui/material/';

export const globalLogin = css`
  body {
    background-color: ${MUI_PRIMARY_MAIN};
  }
`;

export const LoginContainer = styled(Container)`
  flex-direction: column;
  align-items: center;
  gap: 24px;
  display: flex;
  justify-content: center;
  height: 100vh;
`;

export const LoginLogo = styled.img`
  min-width: 245px;
`;

export const LoginTitle = styled(Typography)`
  font-weight: 300;
  color: #ffffff;
  line-height: normal;
`;
export const LoginFormBox = styled(Box)`
  background-color: #ffffff;
  flex-direction: column;
  align-items: center;
  border-radius: 8px;
  gap: 24px;
  display: flex;
  padding: 24px;

  @media (min-width: 0px) {
    width: 444px;
  }
`;

export const StyledLoader = styled(CircularProgress)`
  color: #ffffff;
`;
